"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const account_1 = require("../../account");
// we need to preserve ETH pendingOperations because there is no mempool to do this
// we assume we need to preserve until:
// - that txid appears in operations
// - the nonce is still lower than the last one in operations
const postSyncPatchGen = (initial, synced, latestNonce, mainAccount, parentPendingOperation) => {
    const pendingOperations = initial.pendingOperations || [];
    if (pendingOperations.length === 0)
        return synced;
    const { operations } = synced;
    synced.pendingOperations = pendingOperations.filter(op => (!parentPendingOperation || // a child pending parent need to disappear if parent eth op disappear
        parentPendingOperation.some(o => o.hash === op.hash)) &&
        op.transactionSequenceNumber !== undefined &&
        op.transactionSequenceNumber > latestNonce && // retain logic
        ((0, account_1.shouldRetainPendingOperation)(mainAccount, op) || // after retain logic, we need operation to appear
            !operations.some(o => o.hash === op.hash)));
    return synced;
};
const postSyncPatch = (initial, synced) => {
    const last = synced.operations.find(op => ["OUT", "FEES"].includes(op.type));
    const latestNonce = (last === null || last === void 0 ? void 0 : last.transactionSequenceNumber) || -1;
    const acc = postSyncPatchGen(initial, synced, latestNonce, synced);
    const { subAccounts, pendingOperations } = acc;
    const initialSubAccounts = initial.subAccounts;
    if (subAccounts && initialSubAccounts) {
        acc.subAccounts = subAccounts.map(subAccount => {
            const initialSubAccount = initialSubAccounts.find(a => a.id === subAccount.id);
            if (!initialSubAccount)
                return subAccount;
            return postSyncPatchGen(initialSubAccount, subAccount, latestNonce, acc, pendingOperations);
        });
    }
    return acc;
};
exports.default = postSyncPatch;
//# sourceMappingURL=postSyncPatch.js.map